var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTensorFlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E55B2D;}\r\n\t.st1{fill:#ED8E24;}\r\n\t.st2{fill:#F8BF3C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tensor_Flow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4508",
    className: "st0",
    d: "M68.4,27.7v7.7l13.3,7.7v-7.7L68.4,27.7z M41.7,35.4v7.7l6.7,3.9v-7.7L41.7,35.4z M61.7,39.2 L55,43.1v23.1l6.7,3.8V54.6l6.7,3.8v-7.7l-6.7-3.8V39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4491",
    className: "st1",
    d: "M68.4,27.7l-20,11.5v7.7l13.3-7.7v7.7l6.7-3.9V27.7z M88.4,31.5l-6.7,3.8v7.7l6.7-3.8V31.5z  M75,46.9l-6.7,3.8v7.7l6.7-3.8V46.9z M68.4,58.5l-6.7-3.8V70l6.7-3.8V58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4506",
    className: "st2",
    d: "M68.4,20L41.7,35.4l6.7,3.8l20-11.5l13.3,7.7l6.7-3.8L68.4,20z M68.4,43.1l-6.7,3.9l6.7,3.8 l6.7-3.8L68.4,43.1z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensorFlow);
export default __webpack_public_path__ + "static/media/TensorFlow.50c3cd41a328ff642ce06d0ee2617219.svg";
export { ForwardRef as ReactComponent };